const APPS = ["Coffre", "Factures", "Agenda", "RDV", "Mail", "Kanban", "Signature"];

export function Welcome({ onChoose }: { onChoose: () => void }) {

  return (
    <section className="crm-stage relative flex h-full items-center justify-center overflow-hidden px-6 py-10">
      <div className="relative w-full max-w-4xl text-center">
        <p className="crm-rise text-[11px] font-semibold uppercase tracking-[0.22em] crm-ink">Première connexion</p>
        <h2 className="crm-title crm-rise crm-d1 mt-4 whitespace-nowrap text-4xl font-semibold tracking-tight text-slate-900">
          Un CRM intelligent, branché à vos apps
        </h2>
        <p className="crm-rise crm-d2 mx-auto mt-4 max-w-lg text-[15px] leading-relaxed text-slate-600">
          Celles déjà ouvertes dans votre espace. Le suivi de l’activité reste au même endroit, pour toute l’équipe.
        </p>

        <ul className="mx-auto mt-8 flex flex-nowrap items-center justify-center gap-1.5">
          {APPS.map((name, index) => (
            <li
              key={name}
              className="crm-chip shrink-0 whitespace-nowrap rounded-full border border-white/80 bg-white/90 px-3 py-1.5 text-sm font-medium text-slate-700 shadow-sm"
              style={{ animationDelay: `${0.25 + index * 0.06}s` }}
            >
              {name}
            </li>
          ))}
        </ul>

        <div className="crm-line mx-auto mt-8 w-40" />

        <article className="crm-rise crm-d4 mx-auto mt-8 w-full max-w-lg rounded-3xl border border-white/70 bg-white/85 p-8 text-center shadow-[0_30px_80px_-36px_rgba(43,127,214,0.55)] backdrop-blur-md">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">Pour ouvrir la première fiche</p>
          <h3 className="mt-2 text-2xl font-semibold tracking-tight">Un nom suffit</h3>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            La fiche reçoit son dossier dans CRM clients. Les notes, les pages et les kanbans y vivent.
            Le bloc Coffre s’y ouvre, et vous pouvez naviguer ailleurs dans le Coffre quand vous voulez.
          </p>

          <div className="crm-folder mx-auto mt-6 flex w-fit items-center gap-3 rounded-2xl bg-[#f4f7fb] px-4 py-3 text-slate-700">
            <FolderIcon />
            <span className="text-sm font-medium">CRM clients</span>
          </div>

          <button
            type="button"
            className="mt-6 rounded-full crm-fill px-5 py-2.5 text-sm font-semibold text-white shadow-[0_10px_24px_-12px_rgba(43,127,214,0.9)] transition hover:bg-[#1f6fc4]"
            onClick={onChoose}
          >
            Créer une fiche
          </button>
          <p className="mt-3 text-xs text-slate-400">Le dossier est créé tout seul, au nom de la fiche.</p>
        </article>
      </div>
    </section>
  );
}

function FolderIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75A2.25 2.25 0 0 1 6 4.5h3.2c.5 0 .97.2 1.3.55l1.1 1.2h6.4A2.25 2.25 0 0 1 20.25 8.5v8.75A2.25 2.25 0 0 1 18 19.5H6a2.25 2.25 0 0 1-2.25-2.25V6.75Z" />
    </svg>
  );
}
